import { type JSX, useCallback } from 'react';
import { EmitPageEventCtaActionProvider } from '../../../no-code/components/Notifications/EmitPageEventCtaActionProvider';
import { PageCtaActionProvider } from '../../../no-code/components/Notifications/PageCtaActionProvider';
import { useUrlCtaAction } from '../hooks/useUrlCtaAction';
import type { Cta, UrlCta } from '../types';

function UrlCtaActionProvider({
  cta,
  children,
}: {
  cta: UrlCta;
  children: ({ onClick }: { onClick: () => void }) => JSX.Element;
}) {
  const onClick = useUrlCtaAction();

  const handleClick = useCallback(() => {
    onClick({ cta });
  }, [onClick, cta]);

  return children({ onClick: handleClick });
}

function NotificationActionProvider({
  cta,
  children,
}: {
  cta: Cta | undefined;
  children: ({ onClick }: { onClick: (() => void) | undefined }) => JSX.Element;
}) {
  if (cta?.type === 'page') {
    return <PageCtaActionProvider cta={cta}>{children}</PageCtaActionProvider>;
  } else if (cta?.type === 'url') {
    return <UrlCtaActionProvider cta={cta}>{children}</UrlCtaActionProvider>;
  } else if (cta?.type === 'emitPageEvent') {
    return <EmitPageEventCtaActionProvider cta={cta}>{children}</EmitPageEventCtaActionProvider>;
  }

  return children({ onClick: undefined });
}

export { NotificationActionProvider };
